module.exports = __webpack_public_path__ + "static/media/header_slide_02.3ed5b82a.jpg";